import React, {useState} from "react";
import styled from "styled-components";
import {MAINMENU, SIDEMENU} from "../../framework/consts/menuTypes";

import {MenuButton} from "../../BaseComponents/Button/MenuButton";
import {
    CollapsableMenuItem,
    ItemsScrollWraper,
    MenuButtonWrapper,
    MenuItemText,
    MenuItemTextParent,
    MenuItemWrapper
} from "./index";
import {CSSTransition, TransitionGroup} from "react-transition-group";

const MenuItem = ({
                      Name,
                      Url,
                      Depth,
                      Children,
                      IsActive,
                      IsExpanded,
                      Display,
                      MenuType,
                      LastItem,
                      index,
                  }) => {
    const [expanded, setExpanded] = useState(IsExpanded);
    const [timesOpen, setTimesOpen] = useState(0);
    const [lastIndex, setLastIndex] = useState(LastItem);

    const children = Children?.length
        ? Children.filter(
            (c) =>
                (MenuType == SIDEMENU && !c.IsMobileOnly) || MenuType !== SIDEMENU
        )
        : [];

    const ShowsChildren = expanded && children.length > 0;
    const firstChild = index == 0 && Depth > 2;
    let border = "1px solid rgb(195 195 195)";
    const Borders = {
        BorderTop:
            Depth < 4 || (Depth > 2 && !ShowsChildren && !firstChild) ? border : "",
        BorderBottom:
            (LastItem && !ShowsChildren) || (ShowsChildren && Depth != 2)
                ? border
                : "unset",
        BorderLeft: Depth < 3 ? "unset" : border,
        BorderRadiusBottom: LastItem && !ShowsChildren,
        BorderRadiusTop: Depth == 1,
    };
    const handleClick = (e) => {
        setTimesOpen(timesOpen + 1);
        setExpanded((prevValue) => !prevValue);
    };
    const MenuItemBorder = styled.div`
        display: flex;

        & {
            ${({MenuType, Borders, theme}) =>
                    MenuType == MAINMENU && {
                        borderTop: Borders.BorderTop,
                        borderBottom: Borders.BorderBottom,
                        borderLeft: Borders.BorderLeft,
                        marginLeft: Depth > 2 && Depth * 10 + "px",

                        backgroundColor:
                                Depth == 2 && expanded && children.length > 0
                                        ? theme.colors.bg2
                                        : Depth > 2
                                                ? theme.colors.white
                                                : "",
                    }}
            ${({MenuType, Borders, Border, theme}) =>
                    MenuType == SIDEMENU && {
                        borderBottom: Border,
                        borderLeft: Border,
                        borderRight: Border,
                        borderTopLeftRadius: Depth == 1 ? theme.border.radius : "",
                        borderTopRightRadius: Depth == 1 ? theme.border.radius : "",
                        borderBottomLeftRadius: Borders.BorderRadiusBottom
                                ? theme.border.radius
                                : "",
                        borderBottomRightRadius: Borders.BorderRadiusBottom
                                ? theme.border.radius
                                : "",

                        backgroundColor:
                                Depth == 1
                                        ? theme.colors.primary
                                        : Depth == 2
                                                ? theme.colors.bg2
                                                : theme.colors.white,
                    }}
        }
    `;
    return (
        <CollapsableMenuItem
            MenuType={MenuType}
            IsExpanded={expanded}
            Depth={Depth}
            Display={Display}
        >
            <MenuItemBorder MenuType={MenuType} Borders={Borders} Border={border}>
                <MenuItemWrapper
                    // onClick={(e) => HandleClick(e, Url)}
                    href={Url}
                    IsExpanded={expanded}
                    Depth={Depth}
                    MenuType={MenuType}
                >
                    {children?.length > 0 ? (
                        <MenuItemTextParent
                            Depth={Depth}
                            IsExpanded={ShowsChildren}
                            MenuType={MenuType}
                        >
                            {Name}
                        </MenuItemTextParent>
                    ) : (
                        <MenuItemText Depth={Depth} MenuType={MenuType}>
                            {Name}
                        </MenuItemText>
                    )}
                </MenuItemWrapper>
                {children?.length > 0 && (
                    <MenuButtonWrapper>
                        <MenuButton
                            onClick={(e) => handleClick(e)}
                            inverted
                            Width="30px"
                            Depth={Depth}
                            IsExpanded={expanded}
                            MenuType={MenuType}
                            ShouldAnimate={timesOpen > 0}
                        />
                    </MenuButtonWrapper>
                )}
            </MenuItemBorder>

            <TransitionGroup>
                <ItemsScrollWraper>
                    {expanded &&
                        children.map((subItem, index) => {
                            if (timesOpen > 0) {
                                subItem.IsExpanded = false;
                            }
                            return (
                                <CSSTransition
                                    key={`mobile-menu-child-${index}`}
                                    timeout={{enter: 300, appear: 300, exit: 300}}
                                    classNames="fade"
                                    in={expanded}
                                >
                                    <MenuItem
                                        Display={expanded}
                                        Depth={Depth + 1}
                                        {...subItem}
                                        MenuType={MenuType}
                                        LastItem={lastIndex && index == children.length - 1}
                                        index={index}
                                    ></MenuItem>
                                </CSSTransition>
                            );
                        })}
                </ItemsScrollWraper>
            </TransitionGroup>
        </CollapsableMenuItem>
    );
};
export default MenuItem;
